export const jobpackTableConfig = [
    {
        key: "job_id",
        label: "Jobpack ID",
        width: 2,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "urn",
        label: "URN",
        width: 2,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "timestamp",
        label: "Jobpack Created",
        width: 2,
        sortable: true,
        sortAs: "timestamp",
        keyType: "text",
    },
    {
        key: "job_name",
        label: "Jobpack Name",
        width: 2,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "address",
        label: "Address",
        width: 2,
        sortable: true,
        sortAs: "string",
        keyType: "text",
    },

    {
        key: "start_date",
        label: "Start Date",
        width: 2,
        sortable: true,
        sortAs: "date",
        keyType: "text",
    },
    {
        key: "end_date",
        label: "End Date",
        width: 2,
        sortable: true,
        sortAs: "date",
        keyType: "text",
    },
    {
        key: "areas",
        label: "Areas",
        width: 2,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
    {
        key: "departments",
        label: "Departments",
        width: 2,
        sortable: false,
        sortAs: "string",
        keyType: "text",
    },
];